var d = Object.defineProperty;
var o = (t, e, n) => e in t ? d(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var r = (t, e, n) => o(t, typeof e != "symbol" ? e + "" : e, n);
const s = (t) => t ? `?${Object.keys(t).map((e) => `${e}=${encodeURIComponent(t[e])}`).join("&")}` : "";
class u {
  constructor() {
    r(this, "handlerRef", { id: -1 });
  }
  get handler() {
    return this.handlerRef.id;
  }
  set handler(e) {
    this.handlerRef.id = e;
  }
  clear() {
    clearTimeout(this.handlerRef.id);
  }
}
function h(t, e, n = new u()) {
  let i = !1;
  const l = () => {
    n.handler = setTimeout(() => {
      t(() => {
        i = !0, n.clear();
      }), i || l();
    }, e);
  };
  return l(), n;
}
export {
  s as buildQueryString,
  h as setIntervalWithTimeout
};
